import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { map, take, Observable } from 'rxjs';

import { AppState } from '@fcom/core';

import { BasketActions, getPassengers } from '../store';
import { setStage } from '../store/actions/status.actions';
import { Stage } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class SinglePaxGuard implements CanActivate {
  constructor(private store$: Store<AppState>) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.store$.pipe(select(getPassengers)).pipe(
      take(1),
      map((passengers) => {
        if (passengers.length === 1) {
          this.store$.dispatch(BasketActions.addPaxToBasket(passengers[0]));
          this.store$.dispatch(setStage({ stage: Stage.FLIGHTS }));
        }

        return true;
      })
    );
  }
}
